import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';
import { useMediaLoader } from '../../hooks/useMediaLoader';

import styles from './Prize.module.css';

import bigPresent from '../../assets/images/present.webp';

export const Prize = ({ voteState }) => {
  const prize = useMemo(() => {
    const isCorrect = voteState?.vars.find((v) => v.correct)?.varImgUrl;

    return isCorrect;
  }, [voteState]);

  const { isFullyLoaded } = useMediaLoader(prize || bigPresent, 'image');

  return (
    <AnimatePresence mode="wait">
      {isFullyLoaded && (
        <motion.div
          className={styles.present}
          key={prize}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1, ease: 'easeInOut' }}
        >
          <motion.img
            animate={{
              rotate: [0, 0.5, -0.4, 0.3, -0.2, 0.1, -0.1, 0.2, -0.3, 0.4, 0],
            }}
            transition={{
              rotate: {
                duration: 4,
                delay: 1,
                ease: 'easeInOut',
                repeat: Infinity,
              },
            }}
            src={prize || bigPresent}
            alt=""
            className={styles.prize}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
